import { useMemo } from "react";
import { useSelector } from "react-redux";

export type LocationOption = { key: string; label: string; value: string };

export const useLocationOptions = (): LocationOption[] => {
    const { locations } = useSelector((state: any) => state.booking || {});

    return useMemo<LocationOption[]>(() => {
        const seen = new Set<string>();

        return (locations || []).reduce((acc: LocationOption[], loc: any) => {
            const name = String(loc.PlaceName ?? "").trim();
            if (!name || seen.has(name)) return acc;

            seen.add(name);
            acc.push({ key: String(loc.ID), label: name, value: name });
            return acc;
        }, []);
    }, [locations]);
};
